import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { InstructionsModalService } from "../project-detail/instructions-modal/instructions-modal.service";
import { TrackerService } from "../tracker/tracker.service";

@Component({
  selector: "ab-get-started-modal",
  templateUrl: "./get-started-modal.component.html",
})
export class GetStartedModalComponent {
  constructor(
    private instructionsModalService: InstructionsModalService,
    private trackerService: TrackerService,
    public activeModal: NgbActiveModal,
  ) {}

  public showInstructions() {
    this.trackerService.track("getStartedModalButtonClicked");
    this.activeModal.dismiss();
    this.instructionsModalService.open();
  }

  public dismissModal() {
    this.trackerService.track("getStartedModalDismissed");
    this.activeModal.dismiss();
  }
}
